import type { GcsData } from '../../types/gcs/gcsData';
import type { MissionId } from '../../types/gcs/mission';

export const selectIsRouteToSafePointLocked = (
  data: Map<string, GcsData>,
  gcsId: string,
  missionId: MissionId
): boolean => {
  const gcsData = data.get(gcsId);
  if (!gcsData) return false;

  const failureModeRouteInfo = gcsData.missionFailureModeRouteInfoMap.get(missionId);
  if (!failureModeRouteInfo) return false;

  const lockingInfo = gcsData.missionLockingInfoMap.get(missionId);
  const lockedSegments = lockingInfo?.lockedSegmentsIndices || [];

  const baseIndex = failureModeRouteInfo.routeToSafePointBaseIndex;
  if (baseIndex === undefined || baseIndex === null) {
    return false;
  }

  return lockedSegments.some((segment) => baseIndex >= segment.startIndex && baseIndex <= segment.endIndex);
};
